import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { SearchIcon } from "../../icons"
import ClearFiltersButton from "components/common/ClearFiltersButton"
import styles from "./EmptyState.module.css"

const EmptyState = ({ title, description }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.emptyStateContainer}>
      <h4 className={styles.emptyStateTitle}>{title || t("filterTags.no_experiences_found")}</h4>
      <div className={styles.emptyStateIconWrap}>
        <SearchIcon className={styles.emptyStateIcon} />
      </div>
      <p className={styles.emptyStateDescription}>{description || t("filterTags.no_matches_area")}</p>
      <ClearFiltersButton />
    </div>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}

export default EmptyState
